<script setup>
import {Permissions} from "@/Utils/Permissions";
import {onMounted, reactive} from "vue";
import {ToastUtil} from "@/Utils/ToastUtil";
import {ApiWrapper} from "@/Utils/ApiWrapper";

const props = defineProps({
  clientId: String,
  clientName: String
});

const data = reactive({
  loading: false,
  isClientRep: false,
  isClientRepMessage: '',
  headers: [
    {title:'Claim Number', key: 'claimnumber'},
    {title:'Adjuster', key: 'adjuster'},
    {title:'Claim Age (Days)', key: 'age'},
    {title:'Current Task', key: 'currenttask'},
    {title:'Insured Name', key: 'insuredname'},
    {title:'Client', key: 'name'}
  ],
  claims: []
})

const getData = () =>{
  data.loading = true;
  ApiWrapper.get('claims', 'claims-current-client')
      .then((response) => {
        if(response){
          if(response.claims){
            data.isClientRep = true;
            data.claims = response.claims;
          }
        }
      })
      .catch((err) => {
        if(err.response.status === 404 ){
          data.isClientRep = false;
          data.isClientRepMessage = 'Your email is not linked as an Account Representative to any Clients. If you feel this is in error, please contact support.'
        }
        else{
          ToastUtil.error(err);
        }
      })
      .finally(()=> {
        data.loading = false
      })
}

onMounted(()=>{
  getData();
});

</script>

<template>
  <v-container fluid style="height: auto">
    <v-card height="auto" width="auto" v-if="!data.loading && data.isClientRep">
      <v-card-item>
        <v-card-title>
          Active Client Claims
        </v-card-title>
      </v-card-item>
      <v-card-item>
        <v-row>
          <v-col cols="4">
            <v-text-field v-model="data.search" append-icon="mdi-magnify" label="Search" single-line hide-details
                          class="ml-4"></v-text-field>
          </v-col>
          <v-col>
            <v-btn variant="plain" class="mt-1" icon @click="getData()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table :headers="data.headers" :items="data.claims" :loading="data.loading" :search="data.search">
          <template v-slot:[`item.claimnumber`]="{ item }">
            <RouterLink :to="`/clientclaim/${item.claimid}`">
              {{item.claimnumber}}
            </RouterLink>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <RouterLink :to="`/client/${item.clientsid}`">
              {{item.name}}
            </RouterLink>
          </template>
        </v-data-table>
      </v-card-item>
    </v-card>
    <v-alert color="info" v-else>
      {{data.isClientRepMessage}}
    </v-alert>
  </v-container>
</template>

<style scoped>

</style>